import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";
import {
  ProfileUserInformationAboutMeModel
} from "~~/package/mapper/profile/model/ProfileUserInformationAboutMeModel";
import { ProfilePersonalGenderType } from "~~/package/mapper/profile/model/ProfilePersonalGenderType";
import { UserStatusType } from "~~/package/mapper/user/model/UserStatusType";

export class ProfileUserInformationModel extends Model {
  constructor(
    public id: number = 0,
    public nickName: string = "",
    public firstName: string = "",
    public lastName: string = "",
    public email: string = "",
    public headLine: string = "",
    public uuid: string = "",
    public userStatus: UserStatusType = UserStatusType.NORMAL,
    public phoneNumber: string = "",
    public gender: ProfilePersonalGenderType = ProfilePersonalGenderType.DEFAULT,
    public skills: string = "",
    public links: string[] = ["", ""],
    public locale: string = "",
    public location: string = "",
    public profileImageUrl: string = "",
    public emailExposureFlag: boolean = false,
    public fullNameFlag: boolean = false,
    public aboutMeFlag: boolean = false,
    public activityHistoriesFlag: boolean = false,
    public jobOfferFlag: boolean = false,
    public regionFlag: boolean = false,
    public phoneNumberFlag: boolean = false,
    public genderFlag: boolean = false,
    public linksFlag: boolean = false,
    public skillsFlag: boolean = false,
    public workExperienceFlag: boolean = false,
    public educationFlag: boolean = false,
    public aboutMeVOList: ProfileUserInformationAboutMeModel[] | null = null
  ) {
    super();
  }

  public static create(model: ProfileUserInformationModel): ProfileUserInformationModel {
    return createModel<ProfileUserInformationModel>(ProfileUserInformationModel, { ...model });
  }
}

export class ProfileMenuOpenFlagModel extends Model {
  constructor(
    public fullNameFlag: boolean = false,
    public emailExposureFlag: boolean = false,
    public regionFlag: boolean = false,
    public phoneNumberFlag: boolean = false,
    public genderFlag: boolean = false,
    public linksFlag: boolean = false,
    public skillsFlag: boolean = false,
    public aboutMeFlag: boolean = false,
    public activityHistoriesFlag: boolean = false,
    public workExperienceFlag: boolean = false,
    public educationFlag: boolean = false
  ) {
    super();
  }
}